// src/analytics.js
import ReactGA from "react-ga4";

const initializeAnalytics = (measurementId) => {
  ReactGA.initialize(measurementId);
};

export default initializeAnalytics;